import React from 'react';
import { LoginUserData } from '../LoginForm/LoginForm';
import { CheckCircle, ArrowRight, User, Building } from 'lucide-react';

interface LoginWelcomeProps {
  userData: LoginUserData;
  onContinue: () => void;
}

const LoginWelcome: React.FC<LoginWelcomeProps> = ({ userData, onContinue }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-lg w-full p-8 text-center">
        {/* Success Icon */}
        <div className="mx-auto w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6">
          <CheckCircle className="w-12 h-12 text-green-600" />
        </div>

        {/* Welcome Message */}
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Welcome back, {userData.firstName}!
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          You've successfully signed in to your account.
        </p>

        {/* User & Organization Info */}
        <div className="bg-gray-50 rounded-lg p-6 mb-8 text-left">
          <h3 className="font-semibold text-gray-900 mb-4 flex items-center">
            <User className="w-5 h-5 mr-2" />
            Account Information
          </h3>
          <div className="space-y-3 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-500">Name:</span>
              <span className="font-medium">{userData.firstName} {userData.lastName}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-500">Role:</span>
              <span className="font-medium capitalize">{userData.role}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-500">Job Title:</span>
              <span className="font-medium">{userData.jobTitle}</span>
            </div>
          </div>
        </div>

        <div className="bg-blue-50 rounded-lg p-6 mb-8 text-left">
          <h3 className="font-semibold text-gray-900 mb-4 flex items-center">
            <Building className="w-5 h-5 mr-2" />
            Organization
          </h3>
          <div className="space-y-3 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-500">Company:</span>
              <span className="font-medium">{userData.organization.name}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-500">Industry:</span>
              <span className="font-medium">{userData.organization.industry}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-500">Plan:</span>
              <span className="font-medium capitalize">{userData.organization.plan}</span>
            </div>
          </div>
        </div>

        {/* Continue Button */}
        <button
          onClick={onContinue}
          className="bg-blue-600 text-white px-8 py-4 rounded-lg text-lg font-medium hover:bg-blue-700 transition-colors shadow-lg flex items-center justify-center mx-auto"
        >
          Continue to Dashboard
          <ArrowRight className="w-5 h-5 ml-2" />
        </button>

        {/* Additional Info */}
        <p className="text-sm text-gray-500 mt-6">
          Your workspace is ready and all your projects are exactly as you left them.
        </p>
      </div>
    </div>
  );
};

export default LoginWelcome;
